import {
	Modal,
	ForegroundColors,
	Field,
	Flex,
	Typography,
	Select,
	TextColors,
	FontFamilies,
	FlexChild,
	FileUpload,
	Tag,
	BorderRadius,
	BackgroundColors,
	BorderColors,
	ButtonSize,
} from "@abel-technologies-as/components";
import { ModalHeader, GenericModalFooter } from "@/shared/components";
import { Close } from "@/shared/icons";
import { ModalProps } from "@/shared/types";
import { PersonIcon } from "@/shared/icons";
import { ModalBody, Divider } from "./style";
import { useState } from "react";
import { mediaRowSm, widthRow } from "@/shared/style";
import { useTranslation } from "react-i18next";

export const EditDhcModal = ({ open, setOpen }: ModalProps) => {
	const { t } = useTranslation("dhc");
	const [firstName, setFirstName] = useState<string>("");
	const [lastName, setLastName] = useState<string>("");
	const [email, setEmail] = useState<string>("nick@example.com");
	const [phone, setPhone] = useState<string>("+47 900 00 000");
	const [birthday, setBirthday] = useState<string>("");
	const [fieldsOfNeed, setFieldsOfNeed] = useState<string[]>([]);
	const [role, setRole] = useState<string>("");
	const [qa, setQa] = useState<string>("");
	const [bankAccount, setBankAccount] = useState<string>("1234 56 78900");
	const [address, setAddress] = useState<string>("");
	const [city, setCity] = useState<string>("");
	const [zipCode, setZipCode] = useState<string>("");
	const [country, setCountry] = useState<string>("");

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Modal
			modalFooter={
				<GenericModalFooter
					onCancel={handleClose}
					onConfirm={handleClose}
					confirmLabel={t("save_changes")}
					variant="default"
					size={ButtonSize.SMALL}
					fullWidth
				/>
			}
			onClose={handleClose}
			height="80%"
			isOpen={open}
			modalHeader={
				<ModalHeader
					icon={<PersonIcon color={ForegroundColors.Secondary} width="20" height="17" />}
					title={t("edit_dhc")}
					subTitle={t("edit_dhc_subtitle")}
				/>
			}>
			<ModalBody>
				<Flex mediaSm={mediaRowSm} gap="32px" margin="15px 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("first_name_required")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Field
							placeholder={t("first_name_placeholder")}
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
						/>
					</FlexChild>
				</Flex>

				<Flex mediaSm={mediaRowSm} gap="32px" margin="0 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("last_name_required")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Field
							placeholder={t("last_name_placeholder")}
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
						/>
					</FlexChild>
				</Flex>

				<Flex mediaSm={mediaRowSm} gap="32px" margin="0 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("email_required")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Field placeholder={t("email_placeholder")} value={email} onChange={(e) => setEmail(e.target.value)} />
					</FlexChild>
				</Flex>

				<Flex mediaSm={mediaRowSm} gap="32px" margin="0 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("phone_required")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Flex mediaSm={mediaRowSm} gap="8px">
							<Select
								showSearchBar
								title={t("country")}
								value="NO"
								items={["NO", "SE", "DK", "FI"]}
								onChange={() => {}}
							/>
							<Field placeholder={t("phone_placeholder")} value={phone} onChange={(e) => setPhone(e.target.value)} />
						</Flex>
					</FlexChild>
				</Flex>

				<Flex mediaSm={mediaRowSm} gap="32px" margin="0 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("birthday_required")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Field
							placeholder={t("birthday_placeholder")}
							value={birthday}
							onChange={(e) => setBirthday(e.target.value)}
						/>
					</FlexChild>
				</Flex>

				<Divider />

				<Flex mediaSm={mediaRowSm} gap="32px" margin="15px 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("profile_image_required")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<FileUpload onFileSelect={() => null} />
					</FlexChild>
				</Flex>

				<Divider />

				<Flex mediaSm={mediaRowSm} gap="32px" margin="15px 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("fields_of_need")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Select
							showSearchBar
							title={t("select_field")}
							value=""
							items={["Physical Rehabilitation", "Mental Guidance", "Nutrition", "Fitness"]}
							onChange={(value) => {
								if (value && !fieldsOfNeed.includes(value as string)) {
									setFieldsOfNeed([...fieldsOfNeed, value as string]);
								}
							}}
						/>
						{fieldsOfNeed.length > 0 && (
							<Flex gap="8px" margin="8px 0 0 0" flexWrap="wrap" justifyContent="flex-start">
								{fieldsOfNeed.map((field, index) => (
									<Tag
										borderRadius={`${BorderRadius.FULL}px`}
										padding="2px 8px"
										fontSize="12px"
										fontWeight={500}
										lineHeight="16px"
										gap="4px"
										text={field}
										backgroundColor={BackgroundColors.PrimaryAlt}
										borderColor={BorderColors.Secondary}
										textColor={TextColors.Secondary}
										after={
											<div
												onClick={() => setFieldsOfNeed(fieldsOfNeed.filter((_, i) => i !== index))}
												style={{ cursor: "pointer" }}>
												<Close color={TextColors.Quaternary} width="8" height="8" />
											</div>
										}
									/>
								))}
							</Flex>
						)}
					</FlexChild>
				</Flex>

				<Flex mediaSm={mediaRowSm} gap="32px" margin="0 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("role")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Select
							showSearchBar
							title={t("select_role")}
							value={role}
							items={["DHC Leader", "Senior DHC", "Junior DHC", "DHC Trainee"]}
							onChange={(value) => setRole(value as string)}
						/>
					</FlexChild>
				</Flex>

				<Flex mediaSm={mediaRowSm} gap="32px" margin="0 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("qa")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Select
							showSearchBar
							title={t("select_qa")}
							value={qa}
							items={["QA1", "QA2", "QA3", "QA4"]}
							onChange={(value) => setQa(value as string)}
						/>
					</FlexChild>
				</Flex>

				<Divider />

				<Flex mediaSm={mediaRowSm} gap="32px" margin="15px 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("bank_account_required")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Field
							placeholder={t("bank_account_placeholder")}
							value={bankAccount}
							onChange={(e) => setBankAccount(e.target.value)}
						/>
					</FlexChild>
				</Flex>

				<Flex mediaSm={mediaRowSm} gap="32px" margin="0 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("address")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Field
							placeholder={t("address_placeholder")}
							value={address}
							onChange={(e) => setAddress(e.target.value)}
						/>
					</FlexChild>
				</Flex>

				<Flex mediaSm={mediaRowSm} gap="32px" margin="0 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("city_zip_code")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Flex mediaSm={mediaRowSm} gap="15px">
							<Field
								placeholder={t("city")}
								value={city}
								onChange={(e) => setCity(e.target.value)}
								containerCustomStyles={{ marginLeft: 26 }}
							/>
							<Field placeholder={t("zip")} value={zipCode} onChange={(e) => setZipCode(e.target.value)} />
						</Flex>
					</FlexChild>
				</Flex>

				<Flex mediaSm={mediaRowSm} gap="32px" margin="0 0 15px 0">
					<FlexChild mediaSm={widthRow} alignSelf="baseline" flexBasis="25%" flexGrow={1} flexShrink={1}>
						<Typography
							color={TextColors.Secondary}
							fontFamily={FontFamilies.InterMedium}
							fontWeight={500}
							fontSize="14px"
							lineHeight="20px">
							{t("country")}
						</Typography>
					</FlexChild>
					<FlexChild mediaSm={widthRow} flexBasis="75%" flexGrow={1} flexShrink={1}>
						<Select
							showSearchBar
							title={t("select_country")}
							value={country}
							items={["Norway", "Sweden", "Denmark", "Finland"]}
							onChange={(value) => setCountry(value as string)}
						/>
					</FlexChild>
				</Flex>
			</ModalBody>
		</Modal>
	);
};
